const { EMAIL_REGEX } = require('../utils');

const getError = (field, errors, id) => {
  if (id === undefined){
    return errors.find(error => error.field === field)
  }else{
    const personaError = errors.find(error => error.id === id);
    if (personaError) {
        return personaError.errors.find(error => error.field === field);
    }
  }
}

const validateForm = ({
  customerType, persone, businessName, street, number, cap, city, province, partitaIva, couponValid,
  fiscalCode, email, iva, privacyInfo, privacyData, payment, codiceFatturazione, couponCode, pec
}, locale = 'it') => {
  const errors = [];
  persone.forEach(persona => {
    const { day, name, surname, company, role, email, id } = persona;
    const checkNotEmpty = { day, name, surname };
    const personErrors = [];
    if (customerType === 'azienda') {
      Object.assign(checkNotEmpty, { company, role });
    }
    Object.keys(checkNotEmpty).forEach(key => {
      if (!checkNotEmpty[key]) {
        personErrors.push({
          field: key,
          message: 'empty-field'
        });
      }
    });
    if (!email || !EMAIL_REGEX.test(email)) {
      personErrors.push({
        field: 'email',
        message: 'email-invalid'
      });
    }
    if (personErrors.length) {
      errors.push({
        id,
        errors: personErrors
      });
    }
  });
  const checkNotEmpty = { street, number, cap, city, province, fiscalCode };
  if (customerType === 'azienda') {
    Object.assign(checkNotEmpty, { partitaIva, businessName });
  }
  Object.keys(checkNotEmpty).forEach(key => {
    if (!checkNotEmpty[key]) {
      errors.push({
        field: key,
        message: 'empty-field'
      });
    }
  });
  if (customerType === 'azienda') {
    if (iva !== 'true' && iva !== 'false' && iva !== 'splitpayment') {
      errors.push({
        field: 'iva',
        message: 'field-filled'
      });
    }
    if (!codiceFatturazione && !pec && locale === 'it'){
      errors.push({
        field: 'codiceFatturazione',
        message: 'pec-fatturazione'
      },{
        field: 'pec',
        message: 'pec-fatturazione'
      });
    }
  }
  if (!email || !EMAIL_REGEX.test(email)) {
    errors.push({
      field: 'email',
      message: 'email-invalid'
    });
  }
  if (privacyInfo !== true) {
    errors.push({
      field: 'privacyInfo',
      message: 'field-checked'
    });
  }
  if (privacyData !== true) {
    errors.push({
      field: 'privacyData',
      message: 'field-checked'
    });
  }
  if (!payment){
    errors.push({
      field: 'payment',
      message: 'payment-empty'
    });
  }
  if (couponCode && !couponValid) {
    errors.push({
      field: 'couponCode',
      message: 'coupon-not-validated'
    });
  }
  return errors;
}

module.exports = {
  getError,
  validateForm
}